import React from "react";
import {FooterPoweredWrapper} from "./Layout";
import InvertedLogo from "../Assets/logo_inverted.svg";
import Logo from "../Assets/logo.svg";
import styled, {withTheme} from "styled-components";
import Sizes from "../Assets/Sizes";
import {FormattedMessage, injectIntl} from "react-intl";
import store from '../Store'
import {setLanguage} from "../Containers/Identify/Actions";


const FooterLine = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${p => p.theme.colors.primaryTextInverted};
    padding-bottom: ${Sizes.mediumPadding};
    margin-top: ${props => props.negativeMargin ? '-10px' : 0};

`;

const LinkSmall = styled.a`
    text-decoration: none;
    cursor: pointer;
    color: ${p => p.hasBackgroundImage ? p.theme.colors.textOnBackgroundImage : p.theme.colors.primaryText};
    font-size: 0.9em;
`;

const Div = styled.div`
    ${p => p.hasBackgroundImage ? `color: ${p.theme.colors.textOnBackgroundImage};` : ''};
`;


const SelectWrapper = styled.div`
    position: relative;
    display: block;
    background: transparent;
    overflow: hidden;
    border: 1px solid ${p => p.hasBackgroundImage ? p.theme.colors.textOnBackgroundImage : p.theme.colors.primaryText};
    border-radius: ${Sizes.defaultBorderRadius};
    margin: 0 10px;
    padding-left: ${p => p.ltr ? '8px' : Sizes.smallMargin};
    padding-right: ${p => p.ltr ? '8px' : Sizes.smallMargin};

    &::after {
        content: '';
        position: absolute;
        display: block;
        width: 6px;
        height: 6px;
        border: solid ${p => p.hasBackgroundImage ? p.theme.colors.textOnBackgroundImage : p.theme.colors.primaryText};
        border-width: 0 1px 1px 0;
        transform: rotate(45deg) translateY(-50%);
        pointer-events: none;
        top: 40%;
        left: ${p => p.ltr ? 'auto' : Sizes.smallMargin};
        right: ${p => !p.ltr ? 'auto' : Sizes.mediumPadding};
        z-index: 1;
    }
`

const CustomSelect = styled.select`
    appearance: none;
    outline: 0;
    box-shadow: none;
    background: transparent;
    text-indent: 0;
    color: ${p => p.hasBackgroundImage ? p.theme.colors.textOnBackgroundImage : p.theme.colors.primaryText};
    border: none;
    padding: ${Sizes.textMargin} 0;
    cursor: pointer;
    width: 55px;


    &::-ms-expand {
        display: none;
    }
`;

const Footer = (props) => {
    let he = props.intl.formatMessage({id: 'app.he'})
    let en = props.intl.formatMessage({id: 'app.en'})

    const lang = props.intl.locale.includes('he') ? 'he-IL' : 'en-US';
    const ltr = !props.intl.locale.includes('he');
    let inverted = props.inverted;

    let logo = inverted ? InvertedLogo : Logo;
    if (!props.hasBackgroundImage && props.theme.properties.darkLogo) {
        logo = InvertedLogo;
    }

    return (<FooterLine {...props}>
        <FooterPoweredWrapper href="https://easybizy.net">
            <Div {...props}>Powered by</Div>
            <img src={logo}/>
        </FooterPoweredWrapper>
        <SelectWrapper {...props} ltr={ltr}>
            <CustomSelect
                {...props}
                onChange={(ev) => store.dispatch(setLanguage(ev.target.value, true))} value={lang}>
                <option value="he-IL">{he}</option>
                <option value="en-US">{en}</option>
            </CustomSelect>
        </SelectWrapper>
        {props.showTerms && <div>
            <LinkSmall target="_blank" href="https://auth.easybizy.net/privacy-customers" {...props}>
                <FormattedMessage id="app.privacy"/>
            </LinkSmall>
            <LinkSmall target="_blank" href="https://auth.easybizy.net/terms-of-use-customers" {...props}>
                &nbsp;<FormattedMessage id="app.and"/><FormattedMessage id="app.terms"/>
            </LinkSmall>
        </div>}
    </FooterLine>)
}

export default withTheme(injectIntl(withTheme(Footer), {withRef: true}));
